import $ from 'jquery'
import Backbone from 'backbone'
import _ from 'lodash'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import unwrapModel from 'scoreboard/components/unwrap-model'
import selects from 'scoreboard/components/selects'
import template from './trend-line-data-source.hbs'
import updateLineDataSource from './update-line-data-source'
import SerieSelect from '../serie-select'

/**
 * @property {ChartLine} model
 * @property {ChartDesigner} chart
 *
 * @type {TrendLineDataSource}
 */
const TrendLineDataSource = Backbone.View.extend({

	tagName: 'form',

	className: 'trend-line-data-source',

	/**
	 *
	 * @param {ChartDesigner} options.chart
	 */
	initialize: function(options = {}) {
		this.options = options
		this.chart = options.chart

		this.formView = new FormView({
			el: this.el,
			submit: this.save.bind(this)
		})
	},

	render() {
		this.$el.empty().append(template({
		}))
		// #40509 hide “Source Data Range” for trend lines and comment out
		// toggle rendering until #36755 is implemented
		this.$('.source-data-range').addClass('is-not-displayed')
		/*
		this.toggle = new LabeledToggle({
			name: 'sourceDataRange',
			options: [{
				value: 'visible-data',
				label: 'common.visibleData'
			}]
			// {
			// 	value: 'periods',
			// 	label: ''
			// }, {
			// 	value: 'days',
			// 	label: ''
			// }],
		})
		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()
		this.toggle.on('change', function(val) {
			this.formView.change()
		}.bind(this))
		*/

		const { axis, serieSourceId, serieSourceTempId } = unwrapModel(this.model)

		selects(this.$('select'))
		formHelper.writeToDom(this.model, this.el)

		this.serieSourceSelect = SerieSelect.appendAndRender(
			this.$('.source-data-serie'),
			new SerieSelect({
				model: this.chart,
				name: 'serieSource',
				axis,
				includeAll: true,
				selected: {
					id: serieSourceId,
					tempId: serieSourceTempId
				}
			}))

		this.formView.start()

		return this
	},

	save: function() {
		const data = formHelper.readFromDom(this.el)
		updateLineDataSource(this.model, data, this.serieSourceSelect.val())
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.markedSource], 'remove')
	}

})

export default TrendLineDataSource

TrendLineDataSource.__filename__ = 'charts/edit/analytics/trend-line-data-source.js'
